import { AxiosRequestConfig } from "axios";
import Result from "./Result";
import SessionManager from "./session";

export interface IRequestOptions extends AxiosRequestConfig {
    originUrl?: string; // TODO: use baseURL from axios config
    url: string; // mandatory in our case
    method: Uppercase<AxiosRequestConfig["method"]>; // mandatory in our case... and uppercase
}

/**
 * Make request with JSON data.
 * @param opts
 */
export async function requestJson<T>(opts: IRequestOptions): Promise<Result<T>> {
    if (opts.url.includes("undefined")) return new Result(null, "Bad request. Invalid parameters");
    return await SessionManager.requestJson<T>(opts);
}

/**
 * Represents base class of the isomorphic service.
 * Kept for backward compatibility or if additional shared functionality is needed.
 */
export abstract class ServiceBase {
    public async requestJson<T>(opts: IRequestOptions): Promise<Result<T>> {
        return requestJson<T>(opts);
    }
}
